import { z } from "zod";

export const loginSchema = z.object({
    data_inicio: z.string().nonempty("A data de início é obrigatória."),
    data_fim: z.string().nonempty("A data de fim é obrigatória."),

});
